import { Path, SVG } from '@wordpress/primitives';

export default (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style={ { fill: "none" } } stroke="currentColor" strokeWidth="1.5">
		<Path opacity=".25" d="M7.5 18.5L16.5 18.5M16.5 5.5L7.5 5.5" />
		<Path d="M18.5 16.5L18.5 7.5M5.5 7.5L5.5 16.5" />
	</SVG>
);
